<template lang="html">
  <div class="businessUnit">
    <div class="content-i">
        <div class="content-box">
          <div class="row">
            <div class="col-md-12 col-lg-12 col-sm-12">
              <div class="element-wrapper">
                <h6 class="element-header">Business Unit</h6>
                <div class="element-box" v-if="getBusinessUnitInfo">
                  <div class="element-info mb-4">
                    <div class="row align-items-center">
                      <div class="col-sm-8">
                        <div class="element-info-with-icon">
                          <div class="element-info-icon text-center">
                            <div class="os-icon os-icon-users"></div>
                          </div>
                          <div class="element-info-text">
                            <h4 class="element-inner-header" style="margin-bottom: 0px;">{{ getBusinessUnitInfo.name }}</h4>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <form id="formBusinessUnitUpdate" v-on:submit.prevent="updateBusinessUnit">
                    <div class="row">
                      <div class="col-sm-12">
                        <router-link :to="{ name: 'client_configuration' }">
                        <button class="btn btn-secondary"> < Back to Client Configuration</button>
                      </router-link>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-sm-12 col-md-6 col-lg-4">
                        <b-form-group class="mt-3 col-lg-12 col-sm-12 padding-fix">
                          <b-input-group>
                            <b-input-group-prepend class="col-lg-4 col-sm-6 p-0">
                              <b-input-group-text slot="prepend" class="col-12 pretext"><span class="pretext-span">{{ t('buFullNameLabelText', 'buFullNameLabelText') }}</span></b-input-group-text>
                            </b-input-group-prepend>
                            <b-form-input id="business_name" v-model="unitData.name"></b-form-input>
                          </b-input-group>
                        </b-form-group>
                        <b-form-group class="mt-3 col-lg-12 col-sm-12 padding-fix">
                          <b-input-group>
                            <b-input-group-prepend class="col-lg-4 col-sm-6 p-0">
                              <b-input-group-text class="col-12 pretext"><span class="pretext-span">{{ t('buShortNameLabelText', 'buShortNameLabelText') }}</span></b-input-group-text>
                            </b-input-group-prepend>
                            <b-form-input id="business_short_name" required v-model="unitData.short_name"></b-form-input>
                          </b-input-group>
                        </b-form-group>
                        <b-form-group class="mt-3 col-lg-12 col-sm-12 padding-fix">
                          <b-input-group>
                            <b-input-group-prepend class="col-lg-4 col-sm-6 p-0">
                              <b-input-group-text class="col-12 pretext"><span class="pretext-span">{{ t('buWebsiteUrlLabelText', 'buWebsiteUrlLabelText') }}</span></b-input-group-text>
                            </b-input-group-prepend>
                            <b-form-input id="business_website_url" v-model="unitData.website_url"></b-form-input>
                          </b-input-group>
                        </b-form-group>
                        <b-form-group class="mt-3 col-lg-12 col-sm-12 padding-fix">
                          <b-input-group>
                            <b-input-group-prepend class="col-lg-4 col-sm-6 p-0">
                              <b-input-group-text class="col-12 pretext"><span class="pretext-span">{{ t('buPrincipalLabelText', 'buPrincipalLabelText') }}</span></b-input-group-text>
                            </b-input-group-prepend>
                            <b-form-input id="business_principal" v-model="unitData.principle.principle" required></b-form-input>
                          </b-input-group>
                        </b-form-group>
                        <b-form-group class="mt-3 col-lg-12 col-sm-12 padding-fix">
                          <b-input-group>
                            <b-input-group-prepend class="col-lg-4 col-sm-6 p-0">
                              <b-input-group-text class="col-12 pretext"><span class="pretext-span">{{ t('buLogoLabelText', 'buLogoLabelText') }}</span></b-input-group-text>
                            </b-input-group-prepend>
                            <b-form-select v-model="selectedLogo" @change="changeSelectedLogo($event)">
                              <option v-for="logo in getAvailableBusinessUnitLogos" :value="logo.basename">{{ logo.basename }}</option>
                            </b-form-select>
                          </b-input-group>
                        </b-form-group>
                        <b-form-group class="mt-3 col-lg-12 col-sm-12 padding-fix">
                          <b-input-group>
                            <b-input-group-prepend class="col-lg-4 col-sm-6 p-0">
                              <b-input-group-text class="col-12 pretext"><span class="pretext-span">{{ t('buBackgroundLabelText', 'buBackgroundLabelText') }}</span></b-input-group-text>
                            </b-input-group-prepend>
                            <b-form-select v-model="selectedBackground" @change="changeSelectedBackground($event)">
                              <option v-for="background in getAvailableBusinessUnitBackgrounds" :value="background.basename">{{ background.basename }}</option>
                            </b-form-select>
                          </b-input-group>
                        </b-form-group>
                        <b-form-group class="mt-3 col-lg-12 col-sm-12 padding-fix">
                          <b-input-group>
                            <b-input-group-prepend class="col-lg-4 col-sm-6 p-0">
                              <b-input-group-text class="col-12 pretext"><span class="pretext-span">{{ t('buLoginLogoLabelText', 'buLoginLogoLabelText') }}</span></b-input-group-text>
                            </b-input-group-prepend>
                            <b-form-select v-model="selectedLoginLogo" @change="changeSelectedLoginLogo($event)">
                              <option v-for="logo in getAvailableBusinessUnitLogos" :value="logo.basename">{{ logo.basename }}</option>
                            </b-form-select>
                          </b-input-group>
                        </b-form-group>
                        <b-form-group class="mt-3 col-lg-12 col-sm-12 padding-fix">
                          <b-input-group>
                            <b-input-group-prepend class="col-lg-4 col-sm-6 p-0">
                              <b-input-group-text class="col-12 pretext"><span class="pretext-span">{{ t('buLoginBackgroundLabelText', 'buLoginBackgroundLabelText') }}</span></b-input-group-text>
                            </b-input-group-prepend>
                            <b-form-select v-model="selectedLoginBackground" @change="changeSelectedLoginBackground($event)">
                              <option v-for="background in getAvailableBusinessUnitBackgrounds" :value="background.basename">{{ background.basename }}</option>
                            </b-form-select>
                          </b-input-group>
                        </b-form-group>

                        <b-form-group class="mt-3 col-lg-12 col-sm-12 padding-fix">
                          <b-input-group>
                            <b-input-group-prepend class="col-lg-4 col-sm-6 p-0">
                              <b-input-group-text class="col-12 pretext"><span class="pretext-span">{{ t('buLoginBackgroundLabelText', 'buLoginBackgroundLabelText') }}</span></b-input-group-text>
                            </b-input-group-prepend>
                            <b-form-select v-model="selectedLoginBackground" @change="changeSelectedLoginBackground($event)">
                              <option v-for="background in getAvailableBusinessUnitBackgrounds" :value="background.basename">{{ background.basename }}</option>
                            </b-form-select>
                          </b-input-group>
                        </b-form-group>
                        <!-- NETSEND-8 / NETSEND-38, Added new inputs for AR Business Units, PW -->
                        <template v-if="clientName == 'looktest'">
                          <!--<b-form-group class="mt-3 col-lg-12 col-sm-12 padding-fix">
                            <b-input-group>
                              <b-input-group-prepend class="col-lg-4 col-sm-6 p-0">
                                <b-input-group-text class="col-12 pretext"><span class="pretext-span">{{ t('buArProgramStartDate', 'buArProgramStartDate') }}</span></b-input-group-text>
                              </b-input-group-prepend>
                              <datePicker id="ar-start-date" v-model="unitData.ar_start_date" class="form-control text-left" :config="datePickerConfig" :placeholder="'Managed AR Program Start Date'"></datePicker>
                            </b-input-group>
                          </b-form-group>-->
                          <div class="col-lg-12 px-0">
                            <div class="form-group">
                              <label for="invoice-num" class="font-weight-bold d-block text-left">{{ t('buArProgramStartDate','buArProgramStartDate') }}</label>
                              <hr class="my-1">
                              <datePicker id="ar-start-date" v-model="unitData.ar_start_date" class="form-control text-left" :config="datePickerConfig" :placeholder="'Managed AR Program Start Date'"></datePicker>
                            </div>
                          </div>
                          <!--<b-form-group class="mt-3 col-lg-12 col-sm-12 padding-fix">
                            <b-input-group>
                              <b-input-group-prepend class="col-lg-4 col-sm-6 p-0">
                                <b-input-group-text class="col-12 pretext"><span class="pretext-span">{{ t('buChildAddressQuestion', 'buChildAddressQuestion') }}</span></b-input-group-text>
                              </b-input-group-prepend>
                              <b-form-select v-model="unitData.create_child_address_via">
                                <option :value="0">File Upload Only</option>
                                <option :value="1">Transactions and File Upload</option>
                              </b-form-select>
                            </b-input-group>
                          </b-form-group>-->
                          <div class="col-lg-12 px-0">
                            <div class="form-group">
                              <label for="invoice-num" class="font-weight-bold d-block text-left">{{ t('buChildAddressQuestion','buChildAddressQuestion') }}</label>
                              <hr class="my-1">
                              <b-form-select v-model="unitData.create_child_address_via">
                                <option :value="0">File Upload Only</option>
                                <option :value="1">Transactions and File Upload</option>
                              </b-form-select>
                            </div>
                          </div>
                        </template>
                      </div>
                      <div class="col-sm-12 col-md-6 col-lg-8 logos-div text-center">
                        <div class="logo-box col-3">
                          <b class="col-sm-12">Navbar logo</b>
                          <div class="logo-preview mt-2">
                            <img v-if="this.selectedLogo" :src="getImgUrl('businessUnitLogos') + this.selectedLogo" :alt="this.selectedLogo" />
                            <span v-else class="no-logo-img">
                              <span class="no-logo-text">{{ t('noLogoText', 'noLogoText') }}</span>
                            </span>
                          </div>
                        </div>
                        <div class="logo-box col-3">
                          <b class="col-sm-12">Navbar background</b>
                          <div class="logo-preview mt-2">
                            <img v-if="this.selectedBackground" :src="getImgUrl('businessUnitBackgrounds') + this.selectedBackground" :alt="this.selectedBackground" />
                            <span v-else class="no-logo-img">
                              <span class="no-logo-text">{{ t('noLogoText', 'noLogoText') }}</span>
                            </span>
                          </div>
                        </div>
                        <div class="logo-box col-3">
                          <b class="col-sm-12">Login logo</b>
                          <div class="logo-preview mt-2">
                            <img v-if="this.selectedLoginLogo" :src="getImgUrl('businessUnitLogos') + this.selectedLoginLogo" :alt="this.selectedLoginLogo" />
                            <span v-else class="no-logo-img">
                              <span class="no-logo-text">{{ t('noLogoText', 'noLogoText') }}</span>
                            </span>
                          </div>
                        </div>
                        <div class="logo-box col-3">
                          <b class="col-sm-12">Login background</b>
                          <div class="logo-preview mt-2">
                            <img v-if="this.selectedLoginBackground" :src="getImgUrl('businessUnitBackgrounds') + this.selectedLoginBackground" :alt="this.selectedLoginBackground" />
                            <span v-else class="no-logo-img">
                              <span class="no-logo-text">{{ t('noLogoText', 'noLogoText') }}</span>
                            </span>
                          </div>
                        </div>
                      </div>
                      <div class="col-sm-12">
                        <ResponseInfo v-if="getResponseInfo.responseName == 'selectedBusinessUnit'"></ResponseInfo>
                        <div class="form-buttons-w">
                          <button class="btn btn-primary" type="submit">{{ t('buUpdateUnitBtnText', 'buUpdateUnitBtnText') }}</button>
                          <router-link :to="{ name: 'client_configuration' }" class="ml-2">
                            <button class="btn btn-secondary">Cancel</button>
                          </router-link>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ResponseInfo from '@/components/ResponseInfo'
import { clientShortName } from '@/helpers/clientShortName.js'
import { awsUrl } from '@/helpers/awsUrl.js'
import { mapGetters } from 'vuex'
import datePicker from 'vue-bootstrap-datetimepicker'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css'
import moment from 'moment'

export default {
    name: 'BusinessUnit',
    data () {
      return {
        unitData: {
          name: '',
          short_name: '',
          principle: {
            principle: ''
          },
          website_url: '',
          create_child_address_via: 0,
          ar_start_date: null
        },
        selectedLogo: '',
        selectedBackground: '',
        selectedLoginLogo: '',
        selectedLoginBackground: '',
        datePickerConfig: {
          icons: {
            time: 'os-icon os-icon-calendar-time',
            date: 'os-icon os-icon-basic-2-259-calendar',
            up: 'os-icon os-icon-chevron-up',
            down: 'os-icon os-icon-chevron-down',
            previous: 'os-icon os-icon-chevron-left',
            next: 'os-icon os-icon-chevron-right',
            clear: 'os-icon os-icon-trash',
            close: 'os-icon os-icon-cancel-circle'
          },
          showClear: true
        }
      }
    },
    components: {
      ResponseInfo,
      datePicker
    },
    methods: {
      getBusinessUnit() {
        this.$store.dispatch('getBusinessUnit', this.$route.params.id).then(() => {
          // setting currently selected logo value to the one in the business units table

          if(!this.getBusinessUnitInfo) {
            this.$router.push({ name: 'client_configuration' })
          } else {
            this.unitData = this.getBusinessUnitInfo
            this.selectedLogo = this.getBusinessUnitInfo.logo
            this.selectedBackground = this.getBusinessUnitInfo.background
            this.selectedLoginLogo = this.getBusinessUnitInfo.login_logo
            this.selectedLoginBackground = this.getBusinessUnitInfo.login_background

            // we check if the unit logo exists in the availablelogos list, if not we set it to null
            if(!this.getAvailableBusinessUnitLogos.some(logo => logo.basename === this.selectedLogo)){
              this.selectedLogo = ''
            }
            if(!this.getAvailableBusinessUnitBackgrounds.some(background => background.basename === this.selectedBackground)){
              this.selectedBackground = ''
            }
            if(!this.getAvailableBusinessUnitLogos.some(logo => logo.basename === this.selectedLoginLogo)){
              this.selectedLoginLogo = ''
            }
            if(!this.getAvailableBusinessUnitBackgrounds.some(background => background.basename === this.selectedLoginBackground)){
              this.selectedLoginBackground = ''
            }

            this.create_child_address_via = this.getBusinessUnitInfo.create_child_address_via
            this.ar_start_date = this.getBusinessUnitInfo.ar_start_date
          }
        })
      },
      // NETSEND-8 / NETSEND-38, Added new inputs for AR Business Units, PW
      updateBusinessUnit() {
        this.$store.dispatch('updateBusinessUnit', {
          unitData: this.unitData,
          selectedLogo: this.selectedLogo,
          selectedBackground: this.selectedBackground,
          selectedLoginLogo: this.selectedLoginLogo,
          selectedLoginBackground: this.selectedLoginBackground,
          create_child_address_via: this.create_child_address_via,
          ar_start_date: this.ar_start_date
        }).then( () => {
          this.$parent.$refs.navbar
        })
      },
      getImgUrl(type) {
        return awsUrl() + type + '/'
      },
      changeSelectedLogo(value) {
        this.selectedLogo = value
      },
      changeSelectedBackground(value) {
        this.selectedBackground = value
      },
      changeSelectedLoginLogo(value) {
        this.selectedLoginLogo = value
      },
      changeSelectedLoginBackground(value) {
        this.selectedLoginBackground = value
      },
      goBack() {
        this.$router.push('/client_configuration')
      }
    },
    computed: {
      ...mapGetters(['allTemplateDetails', 'getBusinessUnitInfo', 'getAvailableBusinessUnitLogos', 'getAvailableBusinessUnitBackgrounds', 'getResponseInfo']),
      datePickerFormat: {
        get() {
          return "YYYY-MM-DD"
        }
      },
      clientName() {
        let clientName = clientShortName()
        return clientName
      }
    },
    created() {
      this.datePickerConfig.format = this.datePickerFormat
      this.getBusinessUnit()
    }
}
</script>

<style scoped>
  .padding-fix {
    padding: 0px;
  }
  .logo-preview {
    width: 250px;
    height: 250px;
    display: flex;
    align-items: center;
    justify-content: center;
    max-width: 100%;
    max-height: 100%;
    margin-left: auto;
    margin-right: auto;
  }
  .logo-preview > img {
    max-height: 100%;
    max-width: 100%;
  }
  .no-logo-img {
    height: 250px;
    width: 250px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: rgba(236,236,236,0.8);
    box-shadow: 0px 0px 2px gray;
  }
  .no-logo-text {
    font-size: 40px;
  }
  .logos-div {
    display: flex;
    align-items: center;
  }
</style>